<template>
  <div class="testimonial-wrap pb-100">
    <div class="container">
      <div class="row section-margin">
        <div class="col-lg-8">
          <div class="section-title style1">
            <span>Testimonials</span>
            <h2>Read Our Medical Clinic Clients Reviews Discovered For You</h2>
          </div>
        </div>
      </div>
      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="testimonial-slider-one style1"
      >
        <Slide v-for="testimonial in testimonials" :key="testimonial.id">
          <div class="testimonial-card style1">
            <p class="client-quote">{{ testimonial.shortDesc }}</p>
            <div class="client-info-area">
              <div class="client-info-wrap">
                <div class="client-img">
                  <img :src="testimonial.image" alt="Image" />
                </div>
                <div class="client-info">
                  <h3>{{ testimonial.name }}</h3>
                  <span>{{ testimonial.designation }}</span>
                </div>
              </div>
            </div>
            <div class="quote-icon">
              <i class="flaticon-quote-1"></i>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  name: "OurTestimonials",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    testimonials: [
      {
        id: 1,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has.”",
        image: require("../../assets/images/testimonials/client-3.jpg"),
        name: "Jim Morison",
        designation: "Director, BAT",
      },
      {
        id: 2,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has.”",
        image: require("../../assets/images/testimonials/client-2.jpg"),
        name: "Alex Cruis",
        designation: "CEO, IBAC",
      },
      {
        id: 3,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has.”",
        image: require("../../assets/images/testimonials/client-3.jpg"),
        name: "Tom Haris",
        designation: "Engineer, Olleo",
      },
      {
        id: 4,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has.”",
        image: require("../../assets/images/testimonials/client-4.jpg"),
        name: "Harry Jackson",
        designation: "Enterpreneur",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
    },
  }),
});
</script>